import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { Client } from '../api/models';
import { ClientsService } from '../api/services';

@Injectable()
export class ClientPeerService {

  private readonly client: ReplaySubject<Client>;
  private readonly state: ReplaySubject<string>;

  constructor(private clientsService: ClientsService) {
    this.client = new ReplaySubject<Client>(1);
    this.state = new ReplaySubject<string>(1);
  }

  initialize(id: number): void {
    if (id) {
      this.clientsService.getClient({id: id}).subscribe((client: Client) => {
        this.client.next(client);
      });
    }
  }

  get(): Observable<Client> {
    return this.client.asObservable();
  }

  getState(): Observable<string> {
    return this.state.asObservable();
  }

  create(): void {
    this.client.next(<Client>{});
  }

  lock(): void {
    this.state.next('locked');
  }

  unlock(): void {
    this.state.next('unlocked');
  }

  refresh(): void {
    this.get().pipe(take(1)).subscribe((client) => {
      this.initialize(client.id);
    });
  }

  save(client: Client): void {
    let createOrUpdate: Observable<Client>;

    if (client.id) {
      createOrUpdate = this.clientsService.updateClient({id: client.id, body: client});
    } else {
      createOrUpdate = this.clientsService.createClient({body: client});
    }

    createOrUpdate.subscribe((updated: Client) => {
      this.client.next(updated);
      this.state.next('unlocked');
    });
  }

}
